import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { Emitter } from '@patsnap/tahiti-core/common/event';
import { DualViewSettingModel } from '../../models/dual-view-setting-model';
import type { DualViewSetting } from '../../types';
import type { DualViewSettingService } from '../dual-view-setting-service';

@injectable()
export class DualViewSettingServiceImpl implements DualViewSettingService {
    private _onStatesChangeEmitter = new Emitter<DualViewSetting>();
    readonly onStatesChange = this._onStatesChangeEmitter.event;

    constructor(
        @inject(DualViewSettingModel)
        private _model: DualViewSettingModel,
    ) {
        this._model.onStatesChange(this._emitModelDataChange.bind(this));
    }

    private _emitModelDataChange() {
        this._onStatesChangeEmitter.fire(this.getModelData());
    }

    public getModelData() {
        return this._model.modelData;
    }

    public updateSetting(target: DualViewSetting) {
        this._model.update(() => target);
    }
}
